import React from "react";
import { RCCContainer } from "react-common-components";
import { IComponentLoadingContainer } from "./interface";


const LoadingContainer: React.FC<IComponentLoadingContainer> = ({
	loading,
	children,
	backgroundColor,
	hideContent,
	styleInline
}) => (
	<RCCContainer 
		isLoading={loading}
		customLoader={{ color: "purple" }}
		styleInline={`${backgroundColor ? `background-color: ${backgroundColor};` : ""} ${styleInline || ""}`}
		hideContent={hideContent}
	>
		{children}
	</RCCContainer>
);

export default LoadingContainer;
